import { Trans } from "@lingui/react/macro"
import { Link } from "@tanstack/react-router"
import { Button } from "./ui/button"

export function NotFound() {
  return (
    <div className="space-y-2 p-2" role="alert">
      <h2 className="text-xl font-bold">
        <Trans>Not Found</Trans>
      </h2>
      <p>
        <Trans>The page you are looking for does not exist.</Trans>
      </p>
      <p className="flex flex-wrap items-center gap-2">
        <Button type="button" onClick={() => window.history.back()}>
          <Trans>Go Back</Trans>
        </Button>
        <Button asChild variant="secondary">
          <Link to="/">
            <Trans>Home</Trans>
          </Link>
        </Button>
      </p>
    </div>
  )
}
